import React from 'react';
//import axios from 'axios';
import axios from './axios_cg';
import { Button} from 'antd';
import $ from 'jquery';
import './home.less';

import HomeHeadNavigation from './home_pubilc_head';
import HomeBottom from './home_public_bottom';

import new_product_big_img from './static/new_img/product_big_img.jpg'
import new_product_small_img from './static/new_img/product_small_img.jpg'
import new_indoor_big_img from './static/new_img/indoor_big_img.jpg'
import new_indoor_small_img from './static/new_img/indoor_small_img.jpg'
import new_furniture_big_img from './static/new_img/furniture_big_img.jpg'
import new_furniture_small_img from './static/new_img/furniture_small_img.jpg'
import new_exhibition_big_img from './static/new_img/exhibition_big_img.jpg'
import new_exhibition_small_img from './static/new_img/exhibition_small_img.jpg'
import new_scenery_big_img from './static/new_img/scenery_big_img.jpg'
import new_scenery_small_img from './static/new_img/scenery_small_img.jpg'
import new_architecture_big_img from './static/new_img/architecture_big_img.jpg'
import new_architecture_small_img from './static/new_img/architecture_small_img.jpg'
import new_1 from './static/new_img/1.png'
import new_2 from './static/new_img/2.png'
import new_3 from './static/new_img/3.png'
import new_4 from './static/new_img/4.png'
import new_5 from './static/new_img/5.png'
import new_6 from './static/new_img/6.png'
import new_case_img from './static/new_img/case.jpg'
import new_banner_bottom_img from './static/new_img/banner_bottom.jpg'
import new_computer from './static/new_img/computer.jpg'
import new_map from './static/new_img/map.jpg'
import new_video from './static/new_img/Video.png'


class Home extends React.Component {
    captchaIns = null

    constructor(props) {
        super(props);
        this.state = {
            register_modal: false,
            register_result_modal:false,
            register_result_msg:'',
            register_result_msg_color:'#000000',
            login_modal:false,
            login_result_modal:false,
            login_result_msg:'',
            login_result_msg_color:'#000000',
            base_cg_client_url:'',//稳定版本url
            base_cg_version:'',
            base_cg_date:'',
            newest_cg_client_url:'',
            newest_cg_version:'',
            newest_cg_date:'',
            newest_show:'',
            isDisabled:true,
            isDisabled_no:true,//改为默认不可用 只有注册手机号输入后才可以
            wangyi_pic_code:'',
            mobile_code_send_modal: false,
            password_modal_init:false,
            password_modal_end:false,
            password_isDisabled:true,//默认置灰
            password_isDisabled_no:false,
            password_wangyi_pic_code:'',
            password_result_msg:'',
            password_result_modal:false,
            password_email:"none",
            password_emailcode:"none",
            password_mobile:"",
            password_mobilecode:"",
            password_oldpassword:"",
            password_email_isDisabled:true,//邮箱验证码 按钮等是否显示 这个暂时不写.现在只提供 手机/旧密码修改2种方式  2020.6.5 修改特别说明!
            //6 张图片 合1块 切换大小图片
            hover_p:false,// https://blog.csdn.net/fay462298322/article/details/76998324/
            display_code:"none",//注册默认 不显示
            password_type:'mobile',//重置密码选择的类型  默认邮箱(标志字段)
            email_par_display:'',      //重置密码 第1个modal  选择 邮箱重置时 显示的字段
            email_par2_display:'none',
            mobile_par_display:'none', //重置密码 第1个modal  选择 手机重置时 显示的字段
            mobile_par2_display:'none',
            pwd_modal_style: 'web_password_modal',
            checkUnique_result:'',// 记录 check 结果
            password_email_code_modal:false,
            wyy_v1_code:'',//网易云 v1.0 的码 改密码用的
            wyy_v1_code_register:'',//网易云 v1.0 的码 注册用的
            register_mobile_code_modal:false,//注册输入 手机验证码的 modal
            register_mobile:'',
            pic_data:'',
            pwd_email:'',
            login_but_display:'',
            register_but_display:'',//网页头部注册按钮 显示 开关
            login_account_display:'none',
            login_account:'',//登录用户名
            logout_but_display:'none',
            login_pwd_msg:'str',//非空的 str
            register_fail_msg:'str',//非空的 str
            login_pwd_msg_opacity:0,//通过设置同名度 因为空str 哪怕设置了 隐藏占位 也没元素内容
            register_fail_msg_opacity:0,//
            djang_api_url: '/api',
            register_but_to_wyy_display:'',//注册页面 用来点击跳出wyy的 but
            pwd_but_to_wyy_display:'none',//pwd页面 用来点击跳出wyy的 but 默认不显示
            register_send_mobilecode_but_msg:'获取验证码',
            pwd_send_mobilecode_but_msg:'获取验证码',
            pwd_email_form_display:'',
            pwd_email_required:true,
            pwd_mobile_form_display:'none',
            pwd_mobile_required:false,
            base_url:'',
            home_daohang:'',    //CG默认导航栏显示(只有嵌入 xrender网站时,导航栏才隐藏)
            xrender_show:'none',//默认不显示
        };
    }


    componentWillMount () {
        //特别说明: 1. componentWillMount 是子组件还没有加载
        //         2. HomeHeadNavigation 导航是否显示
        //         3. 这里要排除多少 url,要看 src/index.js 中 component={NewHome} ！！！ 定义了多少 路由
        if (this.props.match.path === "/xrender_cg"){
            this.setState({
                home_daohang:'none',
                xrender_show:''
            })
        }

        window.inputValue = function (dom, st) {
            var evt = new InputEvent('input', {
                inputType: 'insertText',
                data: st,
                dataTransfer: null,
                isComposing: false
            });
            dom.value = st;
            dom.dispatchEvent(evt);
        }

        //去获取 banner img
        this.img_get_from_redis_home();

        this.get_banner_data();

        //去获取 product
        this.get_product_data();

        //get 请求获取 客户端文件基础版本的url
        axios.get('/api/download/'
        ).then(response => {
            this.setState({
            base_cg_client_url: response.data.version_base,
            base_cg_version: response.data.version_base_nunber,
            base_cg_date: response.data.version_base_date,
            newest_cg_client_url: response.data.version_newest,
            newest_cg_version: response.data.version_newest_nunber,
            newest_cg_date: response.data.version_newest_date,
            });

            /* 控制是否显示最新版本的下载 */
            if ((response.data.version_newest_nunber === response.data.version_base_nunber) && (response.data.version_base === response.data.version_newest)){
                this.setState({
                  newest_show:'none',
                })
            }else{
                this.setState({
                  newest_show:'',
                })
            }
        })
    }


    componentDidMount() {
        //特别说明: componentDidMount 是子组件已经加载了！
        //固定url 一定是在 这里设置
        if(this.props.match.path === "/register"){
            this.to_child('open_register');
        };

        if(this.props.match.path === "/login"){
            this.to_child('open_login')
        };

        if(this.props.match.path === "/password"){
            this.to_child('open_password');
        };
    }


    /* 最新版本 下载+记录 */
    download_client__newestfile = () => {
        window.location.href = this.state.newest_cg_client_url; //step1: 直接下载 最新版本
        axios.get('/api/cg_download/newest/');
    }


    /*  稳定版本 下载+记录 */
    download_client_file = () => {
        window.location.href = this.state.base_cg_client_url;//step1: 直接下载 稳定(基础)版本
        axios.get('/api/cg_download/base/');
    }


    to_child =(msg)=>{
      this.refs.myHead.setLoginUserMsg(msg);
    }


    //获取banner的数据
    img_get_from_redis_home = () =>{
        var url = '/api/img_get_redis_home_banner/';
        axios.get(url)
        .then((response) => {
          $('#img_CG').attr('src',response.data.result);//首页 banner 从官网中获取
        });
    }


    //banner（图）之外的其他配置
    get_banner_data = () =>{
        var url = '/api/banner_msgs/';
        axios.get(url)
        .then((response) => {
            const home_data = response.data.rows;
            if (home_data[0].banner_url === ""){
                $('#home_banner').attr("href","javascript:;");//href 没有配置,则 不跳转,不回到顶部
                $('#home_banner').attr("target","");
            }else{
                $('#home_banner').attr("href",home_data[0].banner_url);
            }
        });
    }


    //获取product 的数据
    get_product_data = () =>{
        var url = '/api/product_msgs/';
        axios.get(url)
        .then((response) => {
            const rows_data_list = response.data.rows;
            for (var i=0;i<rows_data_list.length;i++){
                const j=i+1;
                $('#D_img_'+j).attr('src',rows_data_list[i].product_img_url);
                $('#date_'+j+'_year').text(rows_data_list[i].product_date.substring(0, 4));
                $('#date_'+j+'_day').text(rows_data_list[i].product_date.substring(5, 10));
                $('#pro_title_'+j).text(rows_data_list[i].product_title);
                $('#pro_words_'+j).text(rows_data_list[i].product_words);

                if (rows_data_list[i].product_article_url === ""){
                    $('.article_'+j).attr("href","javascript:;");//href 没有配置,则 不跳转,不回到顶部
                    $('.article_'+j).attr("target","");
                }else{
                    $('.article_'+j).attr("href",rows_data_list[i].product_article_url);
                }
            }
        });
    }


    //注册初始化
    showRegisterModal = () =>{
        this.to_child('open_register');
    }


    p1_hover =() =>{
        $("#p6_1").attr("src", new_indoor_big_img);
        $("#p6_2").attr("src", new_architecture_small_img);
        $("#p6_3").attr("src", new_exhibition_small_img);
        $("#p6_4").attr("src", new_scenery_small_img);
        $("#p6_5").attr("src", new_product_small_img);
        $("#p6_6").attr("src", new_furniture_small_img);
        $("#p6_1_title").attr("class",'p6_title_big');
        $("#p6_2_title,#p6_3_title,#p6_4_title,#p6_5_title,#p6_6_title").attr("class",'p6_title_small');
        $("#p6_1_title").css("left",'111px');
        $("#p6_2_title").css("left",'260px');
        $("#p6_3_title").css("left",'315px');
        $("#p6_4_title").css("left",'395px');
        $("#p6_5_title").css("left",'460px');
        $("#p6_6_title").css("left",'520px');
    }


    p2_hover =() =>{
        $("#p6_1").attr("src", new_indoor_small_img);
        $("#p6_2").attr("src", new_architecture_big_img);
        $("#p6_3").attr("src", new_exhibition_small_img);
        $("#p6_4").attr("src", new_scenery_small_img);
        $("#p6_5").attr("src", new_product_small_img);
        $("#p6_6").attr("src", new_furniture_small_img);
        $("#p6_2_title").attr("class","p6_title_big");
        $("#p6_1_title,#p6_3_title,#p6_4_title,#p6_5_title,#p6_6_title").attr("class","p6_title_small");
        $("#p6_1_title").css("left",'33px'); /* 改为33 */
        $("#p6_2_title").css("left",'176px');/* 65+111 */
        $("#p6_3_title").css("left",'315px');
        $("#p6_4_title").css("left",'395px');
        $("#p6_5_title").css("left",'460px');
        $("#p6_6_title").css("left",'520px');
    }


    p3_hover =() =>{
        $("#p6_1").attr("src", new_indoor_small_img);
        $("#p6_2").attr("src", new_architecture_small_img);
        $("#p6_3").attr("src", new_exhibition_big_img);
        $("#p6_4").attr("src", new_scenery_small_img);
        $("#p6_5").attr("src", new_product_small_img);
        $("#p6_6").attr("src", new_furniture_small_img);
        $("#p6_3_title").attr("class","p6_title_big");
        $("#p6_1_title,#p6_2_title,#p6_4_title,#p6_5_title,#p6_6_title").attr("class","p6_title_small");
        $("#p6_1_title").css("left",'33px');
        $("#p6_2_title").css("left",'98px'); /* 65+33 */
        $("#p6_3_title").css("left",'241px');/* 130+111 */
        $("#p6_4_title").css("left",'395px');
        $("#p6_5_title").css("left",'460px');
        $("#p6_6_title").css("left",'520px');
    }


    p4_hover =() =>{
        $("#p6_1").attr("src", new_indoor_small_img);
        $("#p6_2").attr("src", new_architecture_small_img);
        $("#p6_3").attr("src", new_exhibition_small_img);
        $("#p6_4").attr("src", new_scenery_big_img);
        $("#p6_5").attr("src", new_product_small_img);
        $("#p6_6").attr("src", new_furniture_small_img);
        $("#p6_4_title").attr("class","p6_title_big");
        $("#p6_1_title,#p6_2_title,#p6_3_title,#p6_5_title,#p6_6_title").attr("class","p6_title_small");
        $("#p6_1_title").css("left",'33px');
        $("#p6_2_title").css("left",'98px');
        $("#p6_3_title").css("left",'163px');/* 130+33 */
        $("#p6_4_title").css("left",'310px');/* 199+111 */
        $("#p6_5_title").css("left",'460px');
        $("#p6_6_title").css("left",'520px');
    }


    p5_hover =() =>{
        $("#p6_1").attr("src", new_indoor_small_img);
        $("#p6_2").attr("src", new_architecture_small_img);
        $("#p6_3").attr("src", new_exhibition_small_img);
        $("#p6_4").attr("src", new_scenery_small_img);
        $("#p6_5").attr("src", new_product_big_img);
        $("#p6_6").attr("src", new_furniture_small_img);
        $("#p6_5_title").attr("class","p6_title_big");
        $("#p6_1_title,#p6_2_title,#p6_3_title,#p6_4_title,#p6_6_title").attr("class","p6_title_small");
        $("#p6_1_title").css("left",'33px');
        $("#p6_2_title").css("left",'98px');
        $("#p6_3_title").css("left",'163px');
        $("#p6_4_title").css("left",'232px');/* 199+33 */
        $("#p6_5_title").css("left",'375px');/* 264+111 */
        $("#p6_6_title").css("left",'520px');
    }


    p6_hover =() =>{
        $("#p6_1").attr("src", new_indoor_small_img);
        $("#p6_2").attr("src", new_architecture_small_img);
        $("#p6_3").attr("src", new_exhibition_small_img);
        $("#p6_4").attr("src", new_scenery_small_img);
        $("#p6_5").attr("src", new_product_small_img);
        $("#p6_6").attr("src", new_furniture_big_img);
        $("#p6_6_title").attr("class","p6_title_big");
        $("#p6_1_title,#p6_2_title,#p6_3_title,#p6_4_title,#p6_5_title").attr("class","p6_title_small");
        $("#p6_1_title").css("left",'33px');
        $("#p6_2_title").css("left",'98px');
        $("#p6_3_title").css("left",'163px');
        $("#p6_4_title").css("left",'232px');
        $("#p6_5_title").css("left",'297px');/* 264+33 */
        $("#p6_6_title").css("left",'443px');/* 332+111 */
    }


    //用户登录或登出
    father_accept_son_msg =(msg)=>{
        if (msg === "登出"){
            this.setState({
                login_account:""
            })
        }
    }


    render() {
        return(
            <>
                {/* 第一部分:Banner */}
                <div id="Header">
                    <a id="home_banner" target="_blank"><img id="img_CG" /></a>

                    {/*
                        注释说明:
                            父组件 (调用)传 子组件用 ref="***" 这种固定格式
                    */}
                    <div style={{ display:this.state.home_daohang }}>
                        <HomeHeadNavigation
                            sou_msg_to_father={(msg)=>{this.father_accept_son_msg(msg)}}
                            ref="myHead"
                        />
                    </div>

                    <div id="Banner_fixed">
                        {/* 客户端安装文件(稳定版本)信息 */}
                        <div className="flex-container">
                            <Button id="header_stable_download" onClick={this.download_client_file}><p>立即下载</p></Button>
                            <div className='base_right'>
                                <h3 className='part1'>版本 {this.state.base_cg_version}</h3>
                                <h3 className='part1'>更新日期 {this.state.base_cg_date}</h3>
                            </div>
                        </div>

                        {/* 客户端安装文件(最新版本)信息 */}
                        <div  className="flex-container" style={{display:this.state.newest_show}}>
                            <Button id="header_newest_download" onClick={this.download_client__newestfile} ><p>最新版本立即下载</p></Button>
                            <div className='newest_right'>
                                <h3 className='part2'>版本 {this.state.newest_cg_version}</h3>
                                <h3 className='part2'>更新日期 {this.state.newest_cg_date}</h3>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 第二部分:产品介绍 */}
                <div id='Product'>
                    {/* 为解决浏览器窗口大小的问题 */}
                    <div id="Product_fixed">
                        <p className='part_title'>产品介绍</p>
                        <p className='part_title_detail'>强大的插件管家 一键触发效率翻倍</p>
                        <p id='product_left_top_1'>CG MAGIC是一款3ds Max 智能化辅助设计插件<br />提升设计师工作效率3倍以上<br />百余项优化功能，只为效率提升</p>
                        <p id='product_left_top_2'>支持软件：
                            <br />
                            <span>3ds Max 2012-2022(Design)
                                <br />
                                V-Ray 2~5.1与Corona 1.6~7
                            </span>
                        </p>
                        <img id="img_map" src={new_map} alt=""/>
                        <img id="img_computer" src={new_computer} alt=""/>
                        <img id="img_video" src={new_video} alt=""/>
                    </div>
                </div>

                {/* 第三部分:功能介绍 */}
                <div id='Function'>
                    <div id="Function_fixed">
                        <p className='part_title'>功能介绍</p>
                        <p className='part_title_detail'>多款亮点功能  操作简单便捷</p>
                        <div id="line_1" className="flex-container">
                            <img id="img_01" src={new_1} alt=""/>
                            <img id="img_02" src={new_2} alt=""/>
                            <img id="img_03" src={new_3} alt=""/>
                        </div>
                        <div id="line_2" className="flex-container">
                            <p id="sec_p1">版本转化</p>
                            <p id="sec_p2">超强渲染</p>
                            <p id="sec_p3">材质转换</p>
                        </div>
                        <div id="line_3" className="flex-container">
                            <p id="Text_description_1">支持3ds Max 文件版本转换，最低可转至3ds Max 2010版 一键转化，从此不求人</p>
                            <p id="Text_description_2">支持V-Ray与Corona的测试渲染，通道渲染，批量渲染 一键出图，超强渲染</p>
                            <p id="Text_description_3">实现标准材质、V-Ray材质与Corona材质相互转换 一键转换，不再出错</p>
                        </div>
                        <div id="line_4" className="flex-container">
                            <img id="img_04" src={new_4} alt=""/>
                            <img id="img_05" src={new_5} alt=""/>
                            <img id="img_06" src={new_6} alt=""/>
                        </div>
                        <div id="line_5" className="flex-container">
                            <p id="sec_p4">参数优化</p>
                            <p id="sec_p5">全面体检</p>
                            <p id="sec_p6">素材管理</p>
                        </div>
                        <div id="line_6" className="flex-container">
                            <p id="Text_description_B_1">实现模型、材质、灯光与渲染参数自动优化 一键优化，极速渲染</p>
                            <p id="Text_description_B_2">全场景全方位体检，异常问题直观知晓 一键修复，不再崩溃</p>
                            <p id="Text_description_B_2_f">全场景全方位体检，异常问题直观知晓 一键修复，不再崩溃</p>{/* 造假,Text_description_B_3 显示正常 */}
                            <p id="Text_description_B_3">模型、材质、贴图，HDR、IES全部管理，网络素材一键搜索 一键整理，文件不丢</p>
                        </div>
                        <Button id="function_download" onClick={this.download_client_file}><p>立即下载</p></Button>
                    </div>
                </div>

                {/* 第四部分:应用场景 */}
                {/* 特别说明:整个第四部分只有图片,不需要画 固定 fixed 长的div */}
                <div id='Apply'>
                    <p className='part_title'>应用场景</p>
                    <p className='part_title_detail'>适用于多业务场景 提供多场景解决方案</p>
                    <div id="small_big_picture" >
                        <img id="p6_1" src={new_indoor_big_img} onMouseOver={ this.p1_hover }/>
                        <img id="p6_2" src={new_architecture_small_img} onMouseOver={ this.p2_hover }/>
                        <img id="p6_3" src={new_exhibition_small_img} onMouseOver={ this.p3_hover }/>
                        <img id="p6_4" src={new_scenery_small_img} onMouseOver={ this.p4_hover }/>
                        <img id="p6_5" src={new_product_small_img} onMouseOver={ this.p5_hover }/>
                        <img id="p6_6" src={new_furniture_small_img} onMouseOver={ this.p6_hover }/>
                        <span id="p6_1_title" className="p6_title_big">室内设计</span>
                        <span id="p6_2_title" className="p6_title_small">建筑设计</span>
                        <span id="p6_3_title" className="p6_title_small">展览设计</span>
                        <span id="p6_4_title" className="p6_title_small">景观设计</span>
                        <span id="p6_5_title" className="p6_title_small">产品设计</span>
                        <span id="p6_6_title" className="p6_title_small">家具设计</span>
                    </div>
                </div>

                {/* 第五部分:产品动态 */}
                <div id='Dynamic'>
                    <div id="Dynamic_fixed">
                        <p className='part_title'>产品动态</p>
                        <div id="D_line_1" className="flex-container">
                            <div id="img_farther_1"><a className="article_1" target="_blank"><img id="D_img_1" alt=""/></a></div>
                            <div id="img_farther_2"><a className="article_2" target="_blank"><img id="D_img_2" alt=""/></a></div>
                            <div id="img_farther_3"><a className="article_3" target="_blank"><img id="D_img_3" alt=""/></a></div>
                        </div>
                        <div id="D_line_2" className="flex-container">
                            <div id="d_t_1" className="d_t_s flex-container">
                                <div className="p_1_l">
                                    <a className="article_1" target="_blank"><p className="L_1_T" id="date_1_day"></p></a>
                                    <a className="article_1" target="_blank"><p className="L_1_B" id="date_1_year"></p></a>
                                </div>
                                <div className="p_1_r" id="flex_l">
                                    <a id="article_title_1" className="article_1" target="_blank"><p className="R_1_T p1_update" id="pro_title_1"></p></a>
                                    <a id="article_words_1" className="article_1" target="_blank"><p className="R_1_B p1_update" id="pro_words_1"></p></a>
                                </div>
                            </div>
                            <div id="d_t_2" className="d_t_s flex-container">
                                <div className="p_1_l">
                                    <a className="article_2" target="_blank"><p className="L_1_T" id="date_2_day"></p></a>
                                    <a className="article_2" target="_blank"><p className="L_1_B" id="date_2_year"></p></a>
                                </div>
                                <div className="p_1_r" id="flex_mid">
                                    <a id="article_title_2" className="article_2" target="_blank"><p className="R_1_T p2_update" id="pro_title_2"></p></a>
                                    <a id="article_words_2" className="article_2" target="_blank"><p className="R_1_B p2_update" id="pro_words_2"></p></a>
                                </div>
                            </div>
                            <div id="d_t_3" className="d_t_s flex-container">
                                <div className="p_1_l">
                                    <a className="article_3" target="_blank"><p className="L_1_T" id="date_3_day"></p></a>
                                    <a className="article_3" target="_blank"><p className="L_1_B" id="date_3_year"></p></a>
                                </div>
                                <div className="p_1_r" id="flex_r">
                                    <a id="article_title_3" className="article_3" target="_blank"><p className="R_1_T p3_update" id="pro_title_3"></p></a>
                                    <a id="article_words_3" className="article_3" target="_blank"><p className="R_1_B p3_update" id="pro_words_3"></p></a>
                                </div>
                            </div>
                        </div>
                        <div id="D_line_3" className="flex-container">
                            <div id="img_farther_4"><a className="article_4" target="_blank"><img id="D_img_4" alt=""/></a></div>
                            <div id="img_farther_5"><a className="article_5" target="_blank"><img id="D_img_5" alt=""/></a></div>
                            <div id="img_farther_6"><a className="article_6"><img id="D_img_6" alt=""/></a></div>
                        </div>
                        <div id="D_line_4" className="flex-container">
                            <div id="d_t_41" className="d_t_s flex-container">
                                <div className="p_1_l">
                                    <a className="article_4" target="_blank"><p className="L_1_T" id="date_4_day"></p></a>
                                    <a className="article_4" target="_blank"><p className="L_1_B" id="date_4_year"></p></a>
                                </div>
                                <div className="p_1_r" id="flex_l_2">
                                    <a id="article_title_4" className="article_4" target="_blank"><p className="R_1_T p4_update" id="pro_title_4"></p></a>
                                    <a id="article_words_4" className="article_4" target="_blank"><p className="R_1_B p4_update" id="pro_words_4"></p></a>
                                </div>
                            </div>
                            <div id="d_t_42" className="d_t_s flex-container">
                                <div className="p_1_l">
                                    <a className="article_5" target="_blank"><p className="L_1_T" id="date_5_day"></p></a>
                                    <a className="article_5" target="_blank"><p className="L_1_B" id="date_5_year"></p></a>
                                </div>
                                <div className="p_1_r" id="flex_mid_2">
                                    <a id="article_title_5" className="article_5" target="_blank"><p className="R_1_T p5_update" id="pro_title_5"></p></a>
                                    <a id="article_words_5" className="article_5" target="_blank"><p className="R_1_B p5_update" id="pro_words_5"></p></a>
                                </div>
                            </div>
                            <div id="d_t_43" className="d_t_s flex-container">
                                <div className="p_1_l">
                                    <a className="article_6"><p className="L_1_T" id="date_6_day"></p></a>
                                    <a className="article_6"><p className="L_1_B" id="date_6_year"></p></a>
                                </div>
                                <div className="p_1_r" id="flex_r_2">
                                    <a id="article_title_6" className="article_6"><p className="R_1_T p6_update" id="pro_title_6"></p></a>
                                    <a id="article_words_6" className="article_6"><p className="R_1_B p6_update" id="pro_words_6"></p></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 第六部分:案例展示 */}
                <div id='Case'>
                    <p className='part_title'>案例展示</p>
                    <img id="img_case" src={new_case_img} alt=""/>
                </div>

                {/* 第七部分 */}
                <div id='Bottom_img'>
                    <img id="img_bottom"  src={new_banner_bottom_img} alt=""/>
                    <p id='bottom_img_p'>免费体验CG MAGIC最新版本</p>
                    {/* CG自己的注册
                    <Button id="bottom_newest_download" onClick={this.showRegisterModal } >
                        <p style={{ display:this.state.home_daohang }} >立即试用</p>
                        <a style={{ display:this.state.xrender_show }} id="xrender_a" href="https://www.xrender.com/v23/register?c=MjoxMjAwMDAwMDcyMDY0Y2NjMDE3MjA2NTAxMGY4NTE5ZQ" target="_blank">
                            <p>立即试用</p>
                        </a>
                    </Button>
                    */}
                    {/* 跳转到 http://www.xrender.com */}
                    <Button id="bottom_newest_download">
                        <a href="https://www.xrender.com/v23/register?c=MjoxMjAwMDAwMDcyMDY0Y2NjMDE3MjA2NTAxMGY4NTE5ZQ" target="_blank">
                            <p style={{color: "white"}}>立即试用</p>
                        </a>
                    </Button>
                </div>

                <div style={{ display:this.state.home_daohang }}>
                    <HomeBottom />
                </div>
            </>
        )
    }
}


export default Home;

